// extracted by mini-css-extract-plugin
export default {"button":"add-product-button__button___yUeeL"};